import { Modal } from '@cma/common'

interface CustomizeMyRecentSalesProps {
  isOpen: boolean
  onClose: () => void
}

export function CustomizeMyRecentSales({
  isOpen,
  onClose
}: CustomizeMyRecentSalesProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Title>My Recent Sales</Modal.Title>
      <div className="mt-2">Content here</div>
    </Modal>
  )
}
